import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'antd';
import { useLogout } from '../../hooks/useLogout';

interface TopbarProps {
  onToggleSidebar: () => void;
  userData: any;
}

export default function Topbar({ onToggleSidebar, userData }: TopbarProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useLogout();

  const userMenu = {
    items: [
      {
        key: '1',
        label: t('dashboard.edit_profile', 'My Profile'),
        icon: <i className="bi bi-person"></i>,
        onClick: () => navigate('/profile'),
      },
      {
        key: '2',
        label: t('dashboard.settings', 'Settings'),
        icon: <i className="bi bi-gear"></i>,
        onClick: () => navigate('/dashboard/settings'),
      },
      {
        type: 'divider' as const,
      },
      {
        key: 'logout',
        label: t('settings.logout', 'Logout'),
        icon: <i className="bi bi-box-arrow-right"></i>,
        danger: true,
        onClick: logout,
      },
    ],
  };

  return (
    <header className="dashboard-topbar">
      <div className="top-left-actions">
        <button className="mobile-toggle-btn" onClick={onToggleSidebar}>
          <i className="bi bi-list"></i>
        </button>
        <div className="dash-searchbar">
          <i className="bi bi-search text-muted"></i>
          <input type="text" placeholder={t('dashboard.search_placeholder')} />
        </div>
      </div>

      <div className="dash-top-actions">
        <button className="dash-action-btn" onClick={() => navigate('/dashboard/add-user-listing')} title={t('dashboard.create_listing')}>
          <i className="bi bi-plus-circle"></i>
        </button>
        <button className="dash-action-btn" title={t('dashboard.notifications')}>
          <i className="bi bi-bell"></i>
          {/* Unread dot example */}
          <span style={{ position: 'absolute', top: 2, right: 3, width: 8, height: 8, background: '#ef4444', borderRadius: '50%' }}></span>
        </button>
        <Dropdown menu={userMenu} placement="bottomRight" arrow trigger={['click']}>
          <div style={{ cursor: 'pointer', padding: '4px' }}>
            <div className="dash-user-avatar" style={{ width: 34, height: 34, fontSize: 13, background: '#f1f5f9', color: '#333' }}>
              {userData?.firstName?.[0]?.toUpperCase() || userData?.email?.[0]?.toUpperCase() || 'U'}
            </div>
          </div>
        </Dropdown>
      </div>
    </header>
  );
}
